import { useMemo } from 'react';
import { useCampaignSettingsSelector } from './useCampaignSettingsSelector';

export const useLookBackPeriodSelector = () => {
  const settings = useCampaignSettingsSelector();

  return useMemo(() => settings.lookBackPeriod, [settings.lookBackPeriod]);
};
